import { os } from '@services/lib/os';
import { Config } from '@services/lib/request';

export function setPageData(event: string, params?: any) {
  try {
    cnzzSendEvent(event);
    (window as any).TorDataService.emitAction(event, params);
  } catch (err) {}
}

export function setEvent(params: { page?: string; action?: string; name: string }) {
  (window as any)._czc &&
    (window as any)._czc.push([
      '_trackEvent',
      params.page || 'common',
      params.action || 'click',
      params.name || '',
      1
    ]);
}

export async function cnzzSendEvent(name: string) {
  setEvent({ name });
}

export async function cnzzSendObjectEvent(params: {
  page?: string;
  action?: string;
  name: string;
  label?: string;
}) {
  setEvent(params);
}

// 玄武和cnzz埋点
export function sentEvent(name: string, params?: any) {
  try {
    cnzzSendEvent(name);
    (window as any).TorDataService.emitAction(name, {
      ...params
    });
  } catch (err) {}
}

export function getPlatform() {
  if (os.isIOS) {
    return 'ios';
  } else if (os.isAndroid) {
    return 'android';
  } else {
    return 'pc';
  }
}

export function isLZWKAPP() {
  return /lycheer/.test(navigator.userAgent.toLocaleLowerCase());
}
export function getResourceOrigin() {
  return Config.MAIN_URL;
}



// WEBPACK FOOTER //
// ./src/utils/util.ts